import { createFileRoute } from '@tanstack/react-router';
import { LayoutPrivado } from '@/features/layout/components/LayoutPrivado';

export const Route = createFileRoute('/admin/_a')({
    component: Component,
});

function Component() {
    return <LayoutPrivado admin={true} />;
}
